/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Clock24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Clock 24">
      <g className="SVG">
        <path
          fill="#0E0E0E"
          d="M11 5a1 1 0 1 1 2 0v6.5l3.6 2.7a1 1 0 0 1-1.2 1.6l-4-3a1 1 0 0 1-.4-.8V5Z"
        />
        <path
          fill="#0E0E0E"
          fillRule="evenodd"
          d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Zm-2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
          clipRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <clipPath>
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

const SIZE_MAP = {
  sm: Clock24,
  md: Clock24,
  lg: Clock24,
  xl: Clock24,
  xxl: Clock24,
  xxxl: Clock24,
};

export const ClockIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'clock-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
